module.exports = __webpack_public_path__ + "media/images/icon-plus-781cb0f303813e78bafd5b9169eb8ffe.svg";